import { useInterpret } from '@xstate/react';
import type { ActorRefFrom } from 'xstate';

import { LastInteractedStoreMachine } from './LastInteractedStore.machine';

// ────────────────────────────────────────────────────────────────────────────────

export const useInitLastInteractedStoreMachine = () =>
  useInterpret(LastInteractedStoreMachine);

export type LastInteractedStoreMachineRefType = ActorRefFrom<
  typeof LastInteractedStoreMachine
>;
